export default __webpack_public_path__ + "static/media/PressStart2P-Regular.00bf2b9f.woff2";